import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useEffect } from 'react';

const PrivacyPolicy = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#2C2E2D] text-[#D9D9D9]">
      <div className="container mx-auto py-16 px-4 max-w-4xl">
        <h1 className="text-3xl font-bold mb-8 text-[#CCF751]">Privacy Policy</h1>
        
        <div className="bg-yellow-900/30 border border-yellow-600/50 text-yellow-200 p-4 rounded-md mb-8">
          <p className="font-medium">⚠️ DISCLAIMER: DRAFT DOCUMENT</p>
          <p className="text-sm mt-2">
            This is a draft Privacy Policy document for demonstration purposes only. 
            This document has not been reviewed by legal professionals and is not suitable for actual use.
            Before launching your service publicly, please have this document reviewed and customized by a legal professional
            to ensure compliance with applicable laws, particularly the EU's General Data Protection Regulation (GDPR).
            This document lacks specific GDPR requirements including detailed data subject rights, retention periods,
            and specific legal bases for processing personal data.
          </p>
        </div>
        
        <div className="space-y-8">
          <section>
            <h2 className="text-xl font-semibold mb-4">1. Introduction</h2>
            <p className="mb-4">
              Your privacy is important to us. It is JobPin's policy to respect your privacy and comply with applicable 
              laws and regulations regarding any personal information we may collect about you.
            </p>
            <p>
              This policy outlines what data we collect, how we use it, and the choices you have regarding your information.
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold mb-4">2. Information We Collect</h2>
            <p className="mb-4">
              We collect information you provide directly to us when you:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-[#D9D9D9]">
              <li>Create an account</li>
              <li>Add job applications to your board</li>
              <li>Update application statuses</li>
              <li>Add notes or details about job applications</li>
              <li>Communicate with us</li>
            </ul>
            <p className="mt-4">
              This information may include your name, email address, job application details, and any other information you choose to provide.
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold mb-4">3. How We Use Your Information</h2>
            <p className="mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-[#D9D9D9]">
              <li>Provide, maintain, and improve our services</li>
              <li>Process and complete transactions</li>
              <li>Send you technical notices and support messages</li>
              <li>Respond to your comments and questions</li>
              <li>Develop new features and services</li>
              <li>Monitor and analyze trends and usage</li>
            </ul>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold mb-4">4. Data Storage and Security</h2>
            <p className="mb-4">
              We use industry-standard security measures to protect your data. Your information is stored in secure 
              databases and is only accessible to authorized personnel.
            </p>
            <p>
              While we strive to protect your personal information, no method of transmission over the Internet 
              or electronic storage is 100% secure, and we cannot guarantee absolute security.
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold mb-4">5. Sharing Your Information</h2>
            <p className="mb-4">
              We do not sell, trade, or otherwise transfer your personal information to outside parties. 
              This does not include trusted third parties who assist us in operating our website, conducting our 
              business, or servicing you, so long as those parties agree to keep this information confidential.
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold mb-4">6. Your Rights</h2>
            <p className="mb-4">
              You have the right to:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-[#D9D9D9]">
              <li>Access the personal information we hold about you</li>
              <li>Request that we correct any inaccurate information</li>
              <li>Request that we delete your account and data</li>
              <li>Object to the processing of your data</li>
              <li>Export your data in a portable format</li>
            </ul>
            <p className="mt-4">
              To exercise any of these rights, please contact us at privacy@jobpin.example.com.
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold mb-4">7. Cookies and Tracking</h2>
            <p className="mb-4">
              We use cookies and similar tracking technologies to track activity on our service and hold certain information. 
              Cookies are files with a small amount of data that may include an anonymous unique identifier.
            </p>
            <p>
              You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. 
              However, if you do not accept cookies, you may not be able to use some portions of our service.
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold mb-4">8. Changes to This Policy</h2>
            <p className="mb-4">
              We may update our Privacy Policy from time to time. We will notify you of any changes by posting 
              the new Privacy Policy on this page and updating the "last updated" date.
            </p>
            <p>
              You are advised to review this Privacy Policy periodically for any changes.
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold mb-4">9. Contact Us</h2>
            <p className="mb-4">
              If you have any questions about this Privacy Policy, please contact us at privacy@jobpin.example.com.
            </p>
          </section>
        </div>
        
        <div className="mt-12 text-center">
          <Link to="/">
            <Button className="bg-[#CCF751] text-[#2C2E2D] hover:bg-[#CCF751]/90">
              Back to Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 